'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Space = require('../../Space/src/Space.js');
var Dialog_module = require('../styles/Dialog.module.less.js');
var DialogContext = require('./DialogContext.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Dialog component is used to show content on top of an overlay that requires user interaction
 *
 * @component
 * @example
 * ```jsx
 * <Footer>content</Dialog>
 * ```
 */
const Footer = React__namespace.forwardRef((props, ref) => {
    const { className, size, direction, justify, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Dialog_module.default);
    const { fullscreen } = React__namespace.useContext(DialogContext.default);
    const classNames = cx(className, 'footer', {
        fullscreen,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'default-direction': !direction,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'default-Justify': !justify,
    });
    return (React__namespace.createElement(Space.Space, { ref: ref, size: reactUtils.isNumber(size) ? size : 12, direction: direction, justify: justify, className: classNames, ...restProps }, children));
});
Footer.defaultProps = {};
Footer.displayName = 'Footer';

exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map
